module.exports = __webpack_public_path__ + "static/media/AB.129cc478.jpg";